'use es6';

import * as SortField from './SortField';
export const SORT_FIELD_ORDER = [SortField.RELEVANCE_DESC, SortField.PARTNER_TIER_DESC, SortField.NEWEST, SortField.NAME_A_Z, SortField.NAME_Z_A];